import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Button } from 'react-bootstrap'

class WerkervaringReferenties extends Component {
    render() {
        return (
            <div>
                <h5><strong>Beheren van referenties</strong></h5>
                <p>Hier kunt u de referenties beheren die u voor uw werkervaring opgeeft.</p>
                <p><LinkContainer to="/werkervaring/referenties"><Button>Referenties beheren</Button></LinkContainer></p>
                <p>Iedere werkervaring moet door een referentie geaccordeerd worden. Hier kunt u voor onbeoordeelde werkervaring een e-mail sturen aan de opgegeven referenties.</p>
                <p><LinkContainer to="/werkervaring/controle"><Button>Stuur referenties een controle e-mail</Button></LinkContainer></p>
            </div>
        );
    }
}

export default WerkervaringReferenties;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Werkervaring/WerkervaringReferenties.js